<template>
  <el-drawer
    :title="drawerTitle"
    size="80%"
    :visible.sync="currentDrawer"
    append-to-body
    direction="rtl"
    @closed="onCancel"
  >
    <div class="component-wrap" v-loading="loading">
      <el-result
        v-if="Object.keys(detail).length == 0"
        icon="info"
        title="提示"
        subTitle="无可用数据"
      >
      </el-result>
      <div v-else>
        <el-row :gutter="12">
          <el-col :sm="24" :md="8">
            <el-carousel
              :interval="5000"
              arrow="always"
              class="product-carousel"
            >
              <el-carousel-item style="height: 100%;">
                <div class="product-cover">
                  <el-image
                    :style="{ height: '100%', margin: '0 auto' }"
                    :src="detail.thumbnail_url"
                    :preview-src-list="[
                      detail.thumbnail_url,
                      detail.cover_image_url,
                    ]"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </el-carousel-item>
              <el-carousel-item>
                <div class="product-cover">
                  <el-image
                    :style="{ height: '100%', margin: '0 auto' }"
                    :src="detail.cover_image_url"
                    :preview-src-list="[
                      detail.thumbnail_url,
                      detail.cover_image_url,
                    ]"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </el-carousel-item>
            </el-carousel>
          </el-col>
          <el-col :sm="24" :md="16">
            <h3 class="product-title">
              {{ detail.name.cn }}-{{ detail.name.en }}
            </h3>
            <p class="product-desc">{{ detail.oneline_description.cn }}</p>
            <div class="platforms mt-t mt-b">
              <el-tag
                v-for="dItem in detail.displayPlatforms"
                :key="dItem.name"
                style="margin: 5px"
                effect="dark"
                :title="`在${dItem.name}平台上展示`"
                >{{ dItem.name }}</el-tag
              >
            </div>
            <el-descriptions :column="2" border>
              <el-descriptions-item label="状态">
                <el-tag type="success" v-if="!detail.disabled">已启用</el-tag>
                <el-tag type="danger" v-if="detail.disabled">已禁用</el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="次序">{{
                detail.seq
              }}</el-descriptions-item>
              <el-descriptions-item label="ID">{{
                detail.id
              }}</el-descriptions-item>
              <el-descriptions-item label="英文名称">{{
                detail.name != null ? detail.name.en : ""
              }}</el-descriptions-item>
              <el-descriptions-item label="中文名称">{{
                detail.name != null ? detail.name.cn : ""
              }}</el-descriptions-item>

              <el-descriptions-item label="系列">{{
                detail.series.map((item) => item.name).join(",")
              }}</el-descriptions-item>

              <el-descriptions-item label="颜色">
                <span v-if="detail.color_name != null"
                  >{{ detail.color_name.cn }}/{{ detail.color_name.en }}</span
                >
              </el-descriptions-item>
              <el-descriptions-item label="对应唯格云产品ID">{{
                detail.vgc_product_id
              }}</el-descriptions-item>
              <el-descriptions-item label="创建人">{{
                detail.user_name_create
              }}</el-descriptions-item>
              <el-descriptions-item label="创建时间">{{
                detail.utc_create | date_time
              }}</el-descriptions-item>
              <el-descriptions-item label="更新人">{{
                detail.user_id_modified
              }}</el-descriptions-item>
              <el-descriptions-item label="修改时间">{{
                detail.utc_modified | date_time
              }}</el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>

        <ModelsOfProduct :productId="detail.id" class="mt-t" />

        <el-row :gutter="10" class="mt-t">
          <el-col :sm="24" :md="16">
            <el-card
              class="box-card"
              shadow="never"
              :bodyStyle="{ minHeight: '300px' }"
            >
              <div slot="header" class="clearfix">
                <span>媒体数据集合</span>
              </div>
              <template v-for="item in detail.normal_medias">
                <el-image
                  v-if="item.type_id == 'IMAGE'"
                  :key="item.url"
                  class="medias-item"
                  :src="item.url"
                  :preview-src-list="
                    detail.normal_medias.map((item) => item.url)
                  "
                >
                </el-image>
                <video
                  v-if="item.type_id == 'VIDEO'"
                  class="medias-item video-obj"
                  :src="item.url"
                  :poster="item.cover_image_url"
                  controls
                  :key="item.url"
                ></video>
              </template>
            </el-card>
          </el-col>
          <el-col :sm="24" :md="8">
            <el-card class="box-card" shadow="never">
              <div slot="header" class="clearfix">
                <span>海报图</span>
              </div>
              <el-image
                style="width: 230px; height: 270px"
                :src="detail.poster_image_url"
                :preview-src-list="[detail.poster_image_url]"
              >
              </el-image>
              <p v-if="detail.poster_slogan != null">
                {{ detail.poster_slogan.cn || "暂无海报标语" }}
              </p>
            </el-card>
          </el-col>
        </el-row>
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>元素图</span>
          </div>
          <template v-for="item in detail.element_medias">
            <el-image
              v-if="item.type_id == 'IMAGE'"
              :key="item.url"
              class="medias-item"
              :src="item.url"
              :preview-src-list="detail.element_medias.map((item) => item.url)"
            >
            </el-image>
            <video
              v-if="item.type_id == 'VIDEO'"
              class="medias-item video-obj"
              :src="item.url"
              :poster="item.cover_image_url"
              controls
              :key="item.url"
            ></video>
          </template>
        </el-card>
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>实拍图</span>
          </div>
          <template v-for="item in detail.photos">
            <el-image
              v-if="item.type_id == 'IMAGE'"
              :key="item.url"
              class="medias-item"
              :src="item.url"
              :preview-src-list="detail.photos.map((item) => item.url)"
            >
            </el-image>
            <video
              v-if="item.type_id == 'VIDEO'"
              class="medias-item video-obj"
              :src="item.url"
              :poster="item.cover_image_url"
              controls
              :key="item.url"
            ></video>
          </template>
        </el-card>
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>一句话描述</span>
          </div>
          <div
            v-if="detail.oneline_description != null"
            v-html="detail.oneline_description.cn"
            class="rich-text-wrap"
          ></div>
        </el-card>

        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>产品描述</span>
          </div>
          <div
            v-if="detail.description != null"
            v-html="detail.description.cn"
            class="rich-text-wrap"
          ></div>
        </el-card>

        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span>图文详情</span>
          </div>
          <div
            v-if="detail.introduction != null"
            v-html="detail.introduction.cn"
            class="rich-text-wrap"
          ></div>
        </el-card>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { isEmprty } from "@/utils/validate";
import { GetProductsById } from "@/views/products/api";
import { compare } from "@/utils/common";
import ModelsOfProduct from "./ModelsOfProduct";

import { ShowApiError } from "@/request/error";
export default {
  name: "ProductDetail",
  components: { ModelsOfProduct },
  props: {
    sid: {
      type: [Number, String],
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentId: null,
      currentDrawer: false,
      loading: false,
      detailsLoading: false,
      detail: {},
    };
  },
  computed: {
    drawerTitle() {
      if (Object.keys(this.detail).length == 0) {
        return "产品详情";
      }
      if (this.detail.name == null) {
        return "产品详情";
      }
      return `${this.detail.name.cn || ""}-${this.detail.name.en || ""}`;
    },
  },
  watch: {
    sid: {
      handler() {
        if (isEmprty(this.sid)) {
          this.currentId = null;
        } else {
          this.currentId = this.sid;
        }
      },
      immediate: true,
    },
    show: {
      handler(value) {
        this.currentDrawer = value;
        if (this.currentDrawer) {
          this.getFormData();
        } else {
          this.detail = {};
        }
      },
      immediate: true,
    },
  },
  methods: {
    isEmprty,
    getFormData() {
      this.loading = true;
      GetProductsById(this.sid)
        .then((res) => {
          this.detail = res.data;
          this.detail.normal_medias = this.detail.normal_medias.sort(
            compare("seq")
          );
          this.detail.element_medias = this.detail.element_medias.sort(
            compare("seq")
          );
          this.detail.photos = this.detail.photos.sort(compare("seq"));
          this.detail.albums = this.detail.albums.sort(compare("seq"));
        })
        .catch((err) => {
          ShowApiError(err, "获取详情数据失败");
        })
        .finally(() => {
          this.loading = false;
          this.detailsLoading = false;
        });
    },
    onCancel() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.component-wrap {
  box-sizing: border-box;
  padding: 0 24px;
  width: 100%;
  position: relative;
  .product-title {
    font-size: 24px;
  }
  .product-desc {
    font-size: 14px;
    color: #686868;
    margin-top: 5px;
  }
  .box-card {
    margin: 10px 0;
  }
  .product-carousel {
    width: 100%;
    height: 390px;
    ::v-deep {
      .el-carousel__container {
        height: 100%;
      }
    }
  }
  .product-cover {
    width: 100%;
    height: 390px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  .model-title {
    font-size: 18px;
  }
}
// .aplha-bg{
//   width: 100%;
//   height: 300px;
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   background: linear-gradient(to bottom,rgba(255,255,255,1) 50%,rgba(255,255,255,.2));
// }
.form-tips {
  font-size: 13px;
  text-align: left;
  padding: 10px;
}
.rich-text-wrap {
  display: block;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  ::v-deep {
    img {
      max-width: 100%;
    }
  }
}
.medias-item {
  display: inline-block;
  width: 140px;
  height: 140px;
  margin: 5px;
}
.video-obj {
  display: inline-block;
  width: 140px;
  height: 140px;
  margin: 5px;
  object-fit: contain;
}
</style>
